import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '/dashboard',
    title: 'Dashboard',
    icon: 'bi bi-speedometer2',
    class: '',
    extralink: false,
    image: './assets/images/icon/dashboard.svg',
    submenu: [],
  },
  {
    path: '',
    title: 'New Trade',
    icon: 'bi bi-arrow-left-right',
    class: '',
    extralink: false,
    image: './assets/images/icon/trade-menu-icon.svg',
    submenu: [],
  },
  {
    path: '',
    title: 'New Credebtor',
    icon: 'bi bi-speedometer2',
    class: '',
    extralink: false,
    image: './assets/images/icon/add-user.svg',
    submenu: [],
  },
  {
    path: '',
    title: 'New Credit Note',
    icon: 'bi bi-subitem-icon',
    class: '',
    extralink: false,
    image: './assets/images/icon/brightness.svg',
    submenu: [],
  },
  {
    path: '',
    title: 'Enter Transaction',
    icon: 'bi bi-subitem-icon',
    class: '',
    extralink: false,
    image: './assets/images/icon/enter-transaction.svg',
    submenu: [],
  },
  {
    path: '',
    title: 'Reconcile Account',
    icon: 'bi bi-subitem-icon',
    class: '',
    extralink: false,
    image: './assets/images/icon/account-reconciliation.svg',
    badge: true,
    badgeCount: 6,
    submenu: [],
  },
  {
    path: 'trading',
    title: 'Trading Summary',
    icon: 'bi bi-subitem-icon',
    class: '',
    extralink: false,
    image: './assets/images/icon/all-trades.svg',
    submenu: [],
  },
  {
    path: 'receipts',
    title: 'Allocated Receipts',
    icon: 'bi bi-subitem-icon',
    class: '',
    extralink: false,
    image: './assets/images/icon/report.svg',
    submenu: [],
  },
  {
    path: 'trading-history',
    title: 'Trading History',
    icon: 'bi bi-subitem-icon',
    class: '',
    extralink: false,
    image: './assets/images/icon/credebtor-overview.svg',
    submenu: [],
  },
  {
    path: 'overdue',
    title: 'Overdue Balance',
    icon: 'bi bi-subitem-icon',
    class: '',
    extralink: false,
    image: './assets/images/icon/overdue-balance.svg',
    submenu: [],
  },
  {
    path: 'rejected',
    title: 'Rejected Trades',
    icon: 'bi bi-subitem-icon',
    class: '',
    extralink: false,
    image: './assets/images/icon/rejected-trades.svg',
    submenu: [],
  },
  {
    path: '',
    title: 'Submit Accounts',
    icon: 'bi bi-subitem-icon',
    class: '',
    extralink: false,
    image: './assets/images/icon/brightness.svg',
    submenu: [],
  },
  {
    path: 'statements',
    title: 'Statements',
    icon: 'bi bi-subitem-icon',
    class: '',
    extralink: false,
    image: './assets/images/icon/monthly-statements.svg',
    submenu: [],
  },
  {
    path: 'fees',
    title: 'Fees',
    icon: 'bi bi-subitem-icon',
    class: '',
    extralink: false,
    image: './assets/images/icon/fee-notices.svg',
    submenu: [],
  },
  {
    path: '',
    title: 'Administration',
    icon: 'bi bi-cash',
    class: 'collapse',
    extralink: false,
    image: './assets/images/icon/admin.svg',
    submenu: [
      {
        path: 'users',
        title: 'Users',
        icon: 'bi bi-speedometer2',
        class: '',
        extralink: false,
        image: './assets/images/icon/add-user.svg',
        submenu: [],
      },
      {
        path: 'currencies',
        title: 'Currencies',
        icon: 'bi bi-speedometer2',
        class: '',
        extralink: false,
        image: './assets/images/icon/currency-configuration.svg',
        submenu: [],
      },
      {
        path: '/profile',
        title: 'View / Edit Profile',
        icon: 'bi bi-subitem-icon',
        class: '',
        extralink: false,
        image: './assets/images/icon/person.svg',
        submenu: [],
      },
      {
        path: '/password',
        title: 'Change Password',
        icon: 'bi bi-subitem-icon',
        class: '',
        extralink: false,
        image: './assets/images/icon/lock.svg',
        submenu: [],
      },
    ],
  },
];
